import React, { Component } from 'react';
import Checkbox from '@mui/material/Checkbox';

// Checkbox wrapper with the sole purpose of allowing toggling without having to repaint the whole row
class RowCheckbox extends Component {

  render() {
    const { selected } = this.props;
    return (<Checkbox {...this.props} checked={selected} />);
  }
}

export default RowCheckbox;
